import { LanguageContext, Language, LanguageContextType } from "./LanguageContext";
import React, { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const translations = {
  no: {
    "tournament.title": "Padel Sosial Turnering",
    "tournament.date": "Dato:",
    "tournament.time": "Klokkeslett:",
    "tournament.location": "Sted:",
    "tournament.courts": "Bane:",
    "tournament.level": "Nivå:",
    "tournament.level.all": "Alle nivåer",
    "tournament.courts.numbers": "2, 3 og 4",
    "tournament.spots": "ledige plasser av totalt",
    "tournament.participants": "Påmeldte deltagere:",
    "tournament.fetching": "Henter deltakerinformasjon... Er du",
    "tournament.logged_in": "innlogget",
    "tournament.welcome": "Velkommen",
    "tournament.deadline": "Frist for avmelding",
    "tournament.24hours": " kl. 15:00 (24 timer før start)",
    "tournament.confirmed": "Gratulerer! Du har sikret deg på turneringen. Vi sees på {day}!",  
    "tournament.waitlist.info": "Dette arrangementet er fullt, men du kan melde deg på venteliste. Hvis en plass blir ledig, vil du bli varslet på e-post.",
    "tournament.waitlist.position": "Du blir nummer",
    "tournament.waitlist.onList": "på ventelisten",
    "tournament.waitlist.button": "Stå på venteliste",
    "tournament.waitlist.joined": "Du står på ventelisten. Hvis en plass blir ledig, vil du bli varslet på e-post.",
    "tournament.waitlist.signup.success": "Du er nå på venteliste, posisjon #{position}. Hvis en plass blir ledig, vil du bli varslet!",
    "tournament.registration.opens": "Påmelding åpnes for alle medlemmer om",
    "tournament.registration.timeUnits": "dag,timer,minutter",
    "tournament.back": "Tilbake til NTNUi Padel Tennis",
    "map": "Kart",
    "tournament.success": "✅ Vellykket",
    "tournament.signup.button": "Meld deg på",
    "tournament.signup.success": "Påmelding vellykket",
    "tournament.signup.waitlist": "Du er nå på venteliste!",
    "tournament.signup.registered": "Du er nå påmeldt",
    "tournament.signup.error": "Kunne ikke melde deg på",
    "tournament.cancel.button": "Fjern påmelding",
    "tournament.cancel.confirm": "Er du sikker på at du vil melde deg av?",
    "tournament.cancel.success": "Avmeldt",
    "tournament.cancel.success.message": "Du er nå fjernet fra turneringen.",
    "tournament.cancel.waitlist.success": "Du er fjernet fra ventelisten.",
    "tournament.cancel.error": "Kunne ikke fjerne deg fra turneringen.",
    "tournament.waitlist.count": "personer på venteliste",
    "tournament.format.americano": "Americano",
    "tournament.format.mexicano": "Mexicano",
    "tournament.format.winner_court": "Vinner-Bane med Splitt",
    "tournament.format.winner_court_team": "Team Vinner-Bane",
    "tournament.format.team_americano": "Team Americano",
    "tournament.mexicano.start": "Start Mexicano Turnering",
    "tournament.mexicano.started": "Mexicano turnering har startet!",
    "tournament.mexicano.round": "Runde {round}",
    "tournament.mexicano.next_round": "Starter runde {round}",
    "tournament.mexicano.court": "Bane {number}",
    "tournament.mexicano.team": "Lag",
    "tournament.mexicano.vs": "vs",
    "tournament.mexicano.score": "Poeng",
    "tournament.mexicano.submit_results": "Lagre resultater",
    "tournament.mexicano.incomplete_results": "Vennligst fyll inn resultater for alle baner",
    "tournament.mexicano.invalid_scores": "Ugyldig score: Vinnerlaget må ha høyere score enn taperlaget og score kan ikke være mer enn 24",
    "tournament.mexicano.finished": "Turneringen er ferdig!",
    "tournament.mexicano.tournament_complete": "Turnering fullført!",
    "tournament.mexicano.leaderboard": "Resultattavle",
    "tournament.mexicano.player": "Spiller",
    "tournament.mexicano.points": "Poeng",
    "tournament.mexicano.matches": "Kamper",
    "tournament.mexicano.reset": "Turneringen er nullstilt",
    "tournament.mexicano.show_leaderboard": "Vis resultattavle",
    "tournament.mexicano.hide_leaderboard": "Skjul resultattavle",
    "tournament.mexicano.winner_team": "Vinner lag",
    "tournament.mexicano.court_assignments": "Baneinndeling",
    "tournament.data_saved": "Resultater lagret i database!",
    "tournament.data_save_failed": "Kunne ikke lagre til database",
    "tournament.mexicano.enter_results": "Registrer resultater",
    "tournament.mexicano.won": "vant",
    "tournament.mexicano.select_left_team_score": "Velg poeng for venstre lag",
    "tournament.mexicano.tie": "Uavgjort",

    // Results page
    "tournament.back_to_tournaments": "Tilbake til turneringer",
    "tournament.in_progress": "Pågår",
    "tournament.completed": "Ferdig",
    "tournament.round_results": "Runderesultater",
    "tournament.round": "Runde",
    "tournament.final_standings": "Sluttresultat",
    "tournament.rounds": "Runder",
    "tournament.players": "Spillere",
    "tournament.not_found": "Turnering ikke funnet",
    "tournament.error_loading_results": "Kunne ikke laste turneringsresultater",
    "tournament.no_results_found": "Ingen turneringsresultater funnet",
    "tournament.past_tournaments": "Tidligere turneringer",
    "tournament.no_past_tournaments": "Ingen tidligere turneringer",

    // Americano translations
    "tournament.americano.start": "Start Americano Turnering",
    "tournament.americano.started": "Americano turnering har startet!",
    "tournament.americano.round": "Runde {round}",
    "tournament.americano.court": "Bane {number}",
    "tournament.americano.team": "Lag",
    "tournament.americano.vs": "vs",
    "tournament.americano.start_round": "Start runde {round}",
    "tournament.americano.finish_round": "Fullfør runde",
    "tournament.americano.leaderboard": "Resultattavle",
    "tournament.americano.player": "Spiller",
    "tournament.americano.points": "Poeng",
    "tournament.americano.games_played": "Kamper spilt",
    "tournament.americano.partners": "Ulike partnere",
    "tournament.americano.position": "Posisjon",
    "tournament.americano.description": "Spillere bytter partner hver runde for variasjon og balanse",
    "tournament.americano.submit_results": "Lagre resultater",
    "tournament.americano.enter_score": "Registrer resultat",
    
    // Team Americano translations  
    "tournament.team_americano.start": "Start Team Americano Turnering",
    "tournament.team_americano.started": "Team Americano turnering har startet!",
    "tournament.team_americano.round": "Runde {round}",
    "tournament.team_americano.court": "Bane {number}",
    "tournament.team_americano.team": "Lag",
    "tournament.team_americano.vs": "vs",
    "tournament.team_americano.start_round": "Start runde {round}",
    "tournament.team_americano.finish_round": "Fullfør runde",
    "tournament.team_americano.leaderboard": "Resultattavle",
    "tournament.team_americano.team_name": "Lag",
    "tournament.team_americano.points": "Poeng",
    "tournament.team_americano.matches_played": "Kamper spilt",
    "tournament.team_americano.position": "Posisjon",
    "tournament.team_americano.description": "Lag forblir sammen gjennom hele turneringen",
    "tournament.team_americano.submit_results": "Lagre resultater",
    "tournament.team_americano.enter_score": "Registrer resultat",
    "event.waitlist.join": "Bli med på venteliste",
    "event.waitlist.leave": "Forlat venteliste",
    "event.waitlist.full": "Arrangementet er fullt. Du kan bli med på ventelisten og vil bli varslet hvis en plass blir ledig.",
    "event.waitlist.position": "Posisjon {position} på ventelisten",
    "event.waitlist.status": "+{count} på venteliste",
    "event.signup.success": "Vellykket påmelding til arrangementet!",
    "event.signup.penalty": "Du kan ikke melde deg på grunnet straff. Sjekk profilen din for detaljer.",
    "event.signup.full": "Arrangementet er fullt. Bli med på ventelisten i stedet.",
    "event.signup.past_event": "Du kan ikke melde deg på et arrangement som allerede har funnet sted.",
    "event.cancel.success": "Du er fjernet fra arrangementet.",
    "event.cancel.penalty": "Du har fått 1 prikk for avmelding mindre enn 3 timer før start.",
    "event.cancel.promoted": "Du er fjernet fra arrangementet. Neste person på ventelisten er varslet.",
    "event.signup.too_early": "Du kan melde deg på {hours} timer før arrangementet starter",
    "event.custom_signup_window": "Påmelding åpner {hours} timer før",
    "event.part_of_series": "Del av gjentakende serie",
    "event.title": "Tittel",
    "event.description": "Beskrivelse",
    "event.date": "Dato",
    "event.time": "Tid",
    "event.location": "Sted",
    "event.level": "Nivå",
    "event.max_participants": "Maks deltakere",
    "event.notes": "Notater",
    "event.type": "Arrangementstype",
    "group.select": "Velg gruppe",
    
    // Admin event occupancy
    "admin.event_occupancy": "Hendelseskapasitet",
    "admin.event_occupancy.slots_filled": "plasser fylt",
    "admin.event_occupancy.on_waitlist": "på venteliste",
    "admin.event_occupancy.full_events": "arrangementer fulle",
    "admin.event_occupancy.high_demand": "Høyt etterspurte arrangementer",
    "admin.event_occupancy.filled": "fylt",
    "admin.event_occupancy.waiting": "venter",
    "admin.event_occupancy.waitlist_badge": "Venteliste",
    "admin.event_occupancy.nearly_full": "Nesten fullt",
    
    // Admin signup window settings
    "admin.signup_window": "Påmeldingsvindu",
    "admin.signup_window_description": "Konfigurer når brukere kan melde seg på arrangementer",
    "admin.default_signup_window": "Standard påmeldingsvindu",
    "admin.default_signup_window_description": "Standard timer før arrangement brukere kan melde seg på",
    "admin.signup_window_save": "Lagre innstillinger",
    "admin.signup_window_hours": "Timer",
    "admin.signup_window_updated": "Påmeldingsvindu oppdatert",
    "admin.edit_event": "Rediger arrangement",
    "admin.delete_event": "Slett arrangement",
    "admin.event_updated": "Arrangement oppdatert",
    "admin.event_deleted": "Arrangement slettet",
    "admin.edit_scope": "Redigeringsomfang",
    "admin.edit_scope.single": "Kun dette arrangementet",
    "admin.edit_scope.future": "Dette og fremtidige",
    "admin.edit_recurring_prompt": "Hvilket omfang vil du redigere?",
    "admin.edit_scope.single_description": "Endringene vil kun gjelde for dette arrangementet",
    "admin.edit_scope.future_description": "Endringene vil gjelde for dette og alle fremtidige arrangementer i serien",
    "admin.edit_scope.confirm": "Bekreft og lagre",
    "admin.custom_signup_window": "Tilpasset påmeldingsvindu",
    "admin.use_default_signup": "Bruk standard",
    "admin.create_event": "Opprett hendelse",
    "admin.create_recurring_event": "Opprett gjentakende",
    "admin.recurrence.none": "Ingen gjentagelse",
    "admin.recurrence.weekly": "Ukentlig",
    "admin.recurrence.biweekly": "Annenhver uke",
    "admin.recurrence.monthly": "Månedlig",
    "admin.recurrence_pattern": "Gjentagelsesmønster",
    "admin.recurrence_end_date": "Sluttdato for gjentagelse",
    "admin.generate_series": "Generer serie",
    "admin.view_series": "Vis serie",
    "admin.delete_series": "Slett serie",
    "admin.delete_scope.single": "Kun denne",
    "admin.delete_scope.future": "Denne og fremtidige",
    "admin.delete_scope.all": "Hele serien",
    "admin.delete_recurring_prompt": "Dette er et gjentakende arrangement. Velg hva du vil slette:",
    "admin.delete_confirm.single_recurring": "Andre arrangement i serien vil bli værende.",
    "admin.delete_confirm.single_standalone": "Er du sikker på at du vil slette dette arrangementet? Denne handlingen kan ikke angres.",
    "admin.delete_confirm.future": "Sletter dette og alle fremtidige arrangement i serien.",
    "admin.delete_confirm.all": "Sletter alle arrangement i denne serien permanent.",
    "admin.event_list": "Alle hendelser",
    "admin.past_events": "Tidligere hendelser",
    "admin.upcoming_events": "Kommende hendelser",
    "admin.event_created": "Hendelse opprettet",
    "admin.series_updated": "Serie oppdatert",
    "event.recurring_badge": "Gjentakende",
    "event.using_default_signup": "Bruker standard påmeldingsvindu",
    "event.past": "Arrangementet har allerede funnet sted",
    "event.details": "Arrangement Detaljer",
    "event.not_found.title": "Arrangement ikke funnet",
    "event.not_found.description": "Arrangementet du leter etter eksisterer ikke.",
    "event.date_time": "Dato & Tid:",
    "event.location_label": "Sted:",
    "event.participants_label": "Deltakere:",
    "event.group_label": "Gruppe:",
    "event.notes_label": "Notater:",
    "event.signed_up": "Du er påmeldt!",
    "event.participants_count": "deltakere",
    "event.waiting_list": "Du står på ventelisten",
    "event.full": "Arrangementet er fullt",
    "event.join": "Meld deg på dette arrangementet",
    "event.join_waiting_list_info": " - Du kan melde deg på ventelisten",
    "event.leave": "Meld deg av",
    "event.leave_waiting_list": "Forlat ventelisten",
    "event.join_button": "Meld deg på",
    "event.join_waiting_list_button": "Meld deg på ventelisten",
    "event.signed_up_participants": "Påmeldte deltakere",
    "event.signup_description": "Personer som har meldt seg på dette arrangementet",
    "event.tournament_type": "Turneringstype",
    "event.select_tournament_type": "Velg turneringstype",
    "event.americano": "Americano",
    "event.mexicano": "Mexicano",
    "event.team_americano": "Team Americano",
    "event.needs_even_players": "(trenger partall spillere)",
    "event.start_tournament": "Start turnering",
    "event.need_more_players": "Trenger {count} flere spillere",
    "event.waiting_list_title": "Venteliste",
    "event.waiting_list_empty": "Ingen på ventelisten",
    "event.position": "Posisjon",
    "event.team_americano_error": "Team Americano krever et partall spillere",
    "event.no_participants": "Ingen deltakere ennå",
    "event.be_first": "Vær den første til å melde deg på!",
    "event.reminder_title": "Påminnelse om arrangement",
    "event.reminders_sent": "Påminnelser sendt til {count} medlemmer",
    "event.reminders_error": "Kunne ikke sende påminnelser",
    "common.current": "Nåværende",
    "common.admin": "Admin",
    "admin.send_reminder": "Send påminnelse",
    
    // Penalty system
    "penalty.admin.title": "Straff-system",
    "penalty.admin.description": "Administrer prikker og straffer",
    "penalty.admin.total_dots": "Totalt prikker",
    "penalty.admin.active_penalties": "Aktive straffer",
    "penalty.admin.late_cancels": "Sene avmeldinger",
    "penalty.admin.no_shows": "Ikke møtt",
    "penalty.admin.assign_no_show": "Gi prikk for ikke-oppmøte",
    "penalty.admin.assign_no_show_description": "Tildel prikk til medlem som ikke møtte",
    "penalty.admin.select_event": "Velg arrangement",
    "penalty.admin.select_event_placeholder": "Velg et arrangement...",
    "penalty.admin.select_member": "Velg medlem",
    "penalty.admin.select_member_placeholder": "Velg et medlem...",
    "penalty.admin.assign_penalty": "Tildel prikk",
    "penalty.admin.recent_penalties": "Nylige straffer",
    "penalty.admin.recent_penalties_description": "Oversikt over siste straffer",
    "penalty.admin.no_penalties": "Ingen straffer registrert",
    "penalty.admin.added": "Prikk tildelt {memberName}",
    "penalty.status.active": "Aktiv",
    "penalty.status.inactive": "Inaktiv",
    "event.admin.participant_removed": "{name} er fjernet fra arrangementet.",
    "event.admin.participant_removed_and_promoted": "{removedName} er fjernet. {promotedName} er flyttet opp fra ventelisten.",
    "event.waitlist.joined": "Du er nå på venteliste, posisjon #{position}. Hvis en plass blir ledig, vil du bli varslet!",
    "event.waitlist.left": "Du er fjernet fra ventelisten.",
    "event.signup.button": "Meld deg på",
    "event.cancel.button": "Avbryt",
    "profile.events": "Mine arrangementer",
    "profile.waitinglist": "Venteliste", 
    "profile.no.events": "Ingen påmeldinger",
    "profile.no.waitinglist": "Ingen venteliste-oppføringer",
    "dashboard.title": "Kommende arrangementer",
    "dashboard.subtitle": "Her er hva som skjer med dine grupper og arrangementer.",
    "dashboard.participants": "deltagere",
    "dashboard.week": "Uke",
    "dashboard.show_past_events": "Vis tidligere arrangementer",
    "dashboard.hide_past_events": "Skjul tidligere arrangementer",
    "dashboard.no_upcoming_events": "Ingen kommende arrangementer akkurat nå. Vis tidligere arrangementer for historikk.",
    "dashboard.no_events_available": "Ingen arrangementer tilgjengelig i dette utvalget.",
    "event.type.training": "Trening",
    "event.type.tournament": "Turnering",
    "event.type.social": "Sosialt",
    "event.group.main": "Hovedgruppe Padel Tennis",
    "event.group.beginners": "Nybegynnergruppe",
    "event.group.advanced": "Avansert gruppe",
    "event.group.social": "Sosial gruppe",
    "event.weekly.title": "Ukentlig Padel Tennis Kamp",
    "event.weekly.description": "Vanlig ukentlig trening for alle ferdighetsnivåer",
    "event.beginner.title": "Nybegynnertrening",
    "event.beginner.description": "Introduksjon til Padel Tennis grunnleggende",
    "event.tournament.title": "Ukentlig Turnering",
    "event.tournament.description": "Americano turnering for alle medlemmer",
    "event.mexicano.title": "Ukentlig Mexicano Turnering",
    "event.mexicano.description": "Mexicano turnering for alle medlemmer",
    "event.practice.title": "Liten Gruppe Øving",
    "event.practice.description": "Intensiv øving for begrenset antall deltagere",
    "event.social.title": "Helge Sosialt Arrangement",
    "event.social.description": "Morsomt sosialt arrangement med mat og drikke",
    "nav.events": "Arrangementer",
    "nav.calendar": "Kalender",
    "nav.notifications": "Varsler",
    
    // Rating system
    "rating.history": "Rangeringhistorikk",
    "rating.history.no_data": "Ingen rangeringsdata tilgjengelig ennå",
    "rating.history.play_matches": "Spill kamper for å bygge rangeringshistorikk",
    "rating.history.match": "Kamp",
    "rating.history.change": "Endring",
    "rating.history.confidence": "Konfidensintervall",
    
    // Calendar translations
    "calendar.week": "Uke",
    "calendar.previous_week": "Forrige uke",
    "calendar.next_week": "Neste uke",
    "calendar.available_spots": "ledige plasser",
    "calendar.full": "Fullt",
    "calendar.court": "bane",
    "calendar.courts": "baner",
    "calendar.capacity": "Kapasitet",
    "calendar.signed_up": "Påmeldte",
    "calendar.today": "I dag",
    "calendar.view_details": "Se detaljer",
    "calendar.click_to_view": "Klikk for å se detaljer",
    "calendar.signup": "Meld deg på",
    "calendar.leave": "Forlat",
    "calendar.join_waitlist": "Bli med på venteliste",
    "calendar.leave_waitlist": "Forlat venteliste",
    "calendar.desktop_only": "Kalendervisning kun tilgjengelig på desktop",
    
    // Event comments
    "event.comments.title": "Kommentarer",
    "event.comments.empty": "Ingen kommentarer ennå. Vær den første til å kommentere!",
    "event.comments.placeholder": "Skriv en kommentar... Bruk @ for å tagge medlemmer",
    "event.comments.submit": "Send",
    "event.comments.delete": "Slett",
    "event.comments.reply": "Svar",
    "event.comments.replying_to": "Svarer til {name}",
    "event.comments.cancel_reply": "Avbryt svar",
    "event.comments.edited": "(redigert)",
    "event.comments.delete_confirm": "Er du sikker på at du vil slette denne kommentaren?",
    "event.comments.mention_notification": "{name} tagget deg i en kommentar",
    "event.comments.success": "Kommentar lagt til",
    "event.comments.error": "Kunne ikke legge til kommentar",
    "event.comments.deleted": "Kommentar slettet",
    "event.comments.delete_error": "Kunne ikke slette kommentar",
    "calendar.desktop_only_message": "Kalendervisningen er kun tilgjengelig på større skjermer for en bedre opplevelse.",
    "nav.messages": "Meldinger",
    "messages.load_earlier": "Last tidligere",
    "loading": "Laster…",
    "messages.new_messages": "Nye meldinger",
    "messages.scroll_to_latest": "Til siste",
    "messages.typing": "skriver…",
    "messages.conversation_not_found": "Samtale ikke funnet",
    "messages.no_messages_yet": "Ingen meldinger ennå. Start samtalen!",
    "messages.you": "Deg",
    "messages.retry": "Prøv igjen",
    "messages.start_chat": "Start chat",
    "messages.failed_to_start_chat": "Kunne ikke starte chat",
    "nav.tournaments": "Turneringer",
    "nav.rankings": "Rangeringer",
    "nav.profile": "Profil",
    "nav.members": "Medlemmer",
    "nav.admin": "Admin",
    "nav.groups": "Grupper",
    "nav.subgroups": "Undergrupper",
    "nav.signout": "Logg ut",
    "rankings.title": "Rangering",
    "rankings.overview": "Spiller Rangering",
    "rankings.player": "Spiller",
    "rankings.rating": "Rating",
    "rankings.deviation": "Avvik",
    "rankings.events": "Økter",
    "rankings.recentActivity": "Siste aktiviteter",
    "rankings.noActivity": "Ingen registrerte aktiviteter",
    "rankings.date": "Dato",
    "rankings.time": "Tid",
    "rankings.event": "Økt",
    "rankings.location": "Sted",
    "welcome.back": "Velkommen tilbake",
    "welcome.members": "Medlemmer",
    "welcome.subgroups": "Undergrupper",
    "admin.title": "Administrasjon",
    "admin.access_denied": "Tilgang nektet",
    "admin.access_denied.message": "Du trenger administratorrettigheter for å få tilgang til denne siden.",
    "admin.total_users": "Totalt antall brukere",
    "admin.active_groups": "Aktive grupper",
    "admin.total_events": "Totalt antall arrangementer",
    "admin.system_health": "Systemhelse",
    "admin.registered_members": "Registrerte medlemmer",
    "admin.including_subgroups": "Inkludert undergrupper",
    "admin.all_time_events": "Alle arrangementer",
    "admin.all_systems_operational": "Alle systemer operative",
    "admin.this_month": "denne måneden",
    "admin.new_groups": "nye grupper",
    "landing.hero.title": "NTNUi Padel",
    "landing.hero.subtitle": "Vil du spille Padel Tennis?",
    "landing.hero.description": "Bli med i vårt livlige padel-miljø! Drop-in økter tilgjengelig hele uken med utstyr inkludert. Alle ferdighetsnivåer velkommen.",
    "landing.hero.join": "Bli med i dag",
    "landing.hero.signin": "Logg inn",
    "landing.auth.signin.title": "Logg inn",
    "landing.auth.signin.description": "Logg inn på din NTNUi Padel-konto",
    "landing.auth.signup.title": "Registrer deg",
    "landing.auth.signup.description": "Opprett en ny NTNUi Padel-konto",
    "app.title": "NTNUi Padel",
    "nav.back": "Tilbake",
    "members.subtitle": "Utforsk alle registrerte medlemmer",
    "members.all": "Alle Medlemmer",
    "members.admins": "Administratorer",
    "members.admin": "Admin",
    "members.add": "Legg til medlem",
    "members.edit": "Rediger medlem",
    "members.delete": "Slett medlem",
    "members.noMembers": "Ingen medlemmer funnet.",
    "members.createMember": "Opprett nytt medlem",
    "members.editMember": "Rediger medlem",
    "members.deleteMember": "Slett medlem",
    "members.memberCreated": "Medlem opprettet",
    "members.memberCreatedDesc": "{{name}} har blitt lagt til",
    "members.memberUpdated": "Medlem oppdatert",
    "members.memberUpdatedDesc": "{{name}} har blitt oppdatert",
    "members.memberDeleted": "Medlem slettet",
    "members.memberDeletedDesc": "{{name}} har blitt fjernet",
    "members.deleteConfirmation": "Er du sikker på at du vil slette {{name}}? Denne handlingen kan ikke angres.",
    "members.deleteWarning": "Dette vil permanent fjerne medlemmet fra alle grupper og turneringer.",
    "members.updateMember": "Oppdater medlem",
    "members.basicInfo": "Grunnleggende informasjon",
    "members.name": "Navn",
    "members.phone": "Telefon",
    "members.email": "E-post",
    "members.enterName": "Skriv inn fullt navn",
    "members.roleAndPermissions": "Rolle og tillatelser",
    "members.role": "Rolle",
    "members.adminPrivileges": "Administratorrettigheter",
    "members.groupMembership": "Gruppemedlemskap",
    "members.groups": "Grupper",
    "members.subgroups": "Undergrupper",
    "members.count.members": "medlemmer",
    "members.count.admins": "administratorer",
    "members.of_total": "av totalt",
    "members.growth": "Vekst",
    "members.last_month": "forrige måned",
    "members.filters": "Filtre",
    "members.advanced_filters": "Avanserte filtre",
    "members.member_type": "Medlemstype",
    "members.admins_only": "Kun administratorer",
    "members.contact_info": "Kontaktinformasjon",
    "members.has_email": "Har e-post",
    "members.has_phone": "Har telefon",
    "members.export": "Eksporter",
    "members.exported": "medlemmer eksportert",
    "members.export_failed": "Eksport feilet",
    "members.contact_completeness": "Kontaktinformasjon fullstendighet",
    "members.complete_contact": "Komplett kontakt",
    "members.missing_email": "Mangler e-post",
    "members.missing_phone": "Mangler telefon",
    "members.editMemberDescription": "Rediger medlemsinformasjon og innstillinger",
    "common.success": "Suksess",
    "common.clear": "Nullstill",
    "groups.filter.select": "Velg grupper",
    
    // Validation
    "validation.required": "Dette feltet er påkrevd",
    "validation.invalidEmail": "Vennligst skriv inn en gyldig e-postadresse",
    "validation.invalidPhone": "Vennligst skriv inn et gyldig telefonnummer",
    "validation.minLength": "Må være minst {{min}} tegn",
    "validation.maxLength": "Må være maksimalt {{max}} tegn",
    "validation.invalidFormat": "Ugyldig format",
    "validation.phoneFormat": "Vennligst skriv inn et gyldig telefonnummer",
    "validation.emailFormat": "Vennligst skriv inn en gyldig e-postadresse",
    "validation.selectGroup": "Vennligst velg minst én gruppe",
    
    // Common
    "common.save": "Lagre",
    "common.saving": "Lagrer...",
    "common.cancel": "Avbryt",
    "common.error": "Feil",
    "common.prev": "Forrige",
    "common.next": "Neste", 
    "common.page": "Side",
    
    // Placeholders
    "placeholder.searchMembers": "Søk medlemmer...",
    "placeholder.phoneNumber": "+47 123 45 678",
    "placeholder.email": "eksempel@epost.com",
    
    // Groups
    "groups.title": "Grupper",
    "groups.subtitle": "Se dine hovedgrupper og medlemmer",
    "groups.subgroups.title": "Undergrupper", 
    "groups.subgroups.subtitle": "Se Padel Tennis undergrupper og deres medlemmer",
    "groups.create": "Opprett gruppe",
    "groups.createSubgroup": "Opprett undergruppe",
    "groups.edit": "Rediger gruppe",
    "groups.members": "medlemmer",
    "groups.subgroups": "undergrupper",
    "groups.events": "arrangementer",
    "groups.expandMembers": "Vis medlemmer",
    "groups.collapseMembers": "Skjul medlemmer",
    "groups.addMember": "Legg til medlem",
    "groups.removeMember": "Fjern medlem",
    "groups.noMembers": "Ingen medlemmer",
    "groups.loading": "Laster grupper...",
    "groups.error": "Kunne ikke laste grupper",
    "groups.memberAdded": "Medlem lagt til",
    "groups.memberRemoved": "Medlem fjernet",
    "groups.unknownMember": "Ukjent medlem",
    "groups.filter.all_groups": "Alle grupper",
    "groups.addMembersTo": "Legg til medlemmer til",
    "groups.roleForSelected": "Rolle for valgte medlemmer",
    "groups.membersSelected": "{{count}} medlem{{count === 1 ? '' : 'mer'}} valgt",
    "groups.noMembersFound": "Ingen medlemmer funnet i søket.",
    "groups.allMembersInGroup": "Alle medlemmer er allerede i denne gruppen.",
    "groups.addMembers": "Legg til {{count}} medlem{{count === 1 ? '' : 'mer'}}",
    "admin.subtitle": "Administrer system og brukere",
    
    // Admin - Tab labels
    "admin.tabs.payments": "Betalinger",
    "admin.tabs.events": "Arrangementer",
    "admin.tabs.tournaments": "Turneringer",
    "admin.tabs.penalties": "Straffer",
    "admin.tabs.system": "System",

    // Admin - Payment section
    "admin.payments.total_revenue": "Total inntekt",
    "admin.payments.revenue_description": "Inntekt fra betalte medlemskap",
    "admin.payments.payments_received": "betalinger mottatt",
    "admin.payments.payment_rate": "betalingsrate",
    "admin.payments.pending_payments": "Ventende betalinger",
    "admin.payments.outstanding_dues": "Utestående kontingent",
    "admin.payments.outstanding": "utestående",
    "admin.payments.overdue": "forfalt",
    "admin.payments.member_status": "Medlemsstatus",
    "admin.payments.current_status": "Nåværende medlemskapsstatus",
    "admin.payments.status.current": "Nåværende",
    "admin.payments.status.pending": "Ventende",
    "admin.payments.status.overdue": "Forfalt",
    "admin.payments.status.paid": "Betalt",
    "admin.payments.status.all": "Alle",
    "admin.payments.quick_actions": "Hurtighandlinger",
    "admin.payments.management_tools": "Verktøy for betalingshåndtering",
    "admin.payments.add_payment": "Legg til betaling",
    "admin.payments.bulk_create": "Masseoppretting",
    "admin.payments.all_records": "Alle betalingsposter",
    "admin.payments.history_tracking": "Komplett betalingshistorikk og statussporing",
    "admin.payments.search_placeholder": "Søk etter medlem eller beskrivelse",
    "admin.payments.filter.status": "Status",
    "admin.payments.sort_by": "Sorter etter",
    "admin.payments.sort.due_date": "Forfallsdato",
    "admin.payments.sort.paid_date": "Betalingsdato",
    "admin.payments.sort.created": "Opprettet",
    "admin.payments.sort.amount": "Beløp",
    "admin.payments.sort.asc": "Stigende",
    "admin.payments.sort.desc": "Synkende",
    "admin.payments.table.member": "Medlem",
    "admin.payments.table.amount": "Beløp",
    "admin.payments.table.due_date": "Forfallsdato",
    "admin.payments.table.paid_date": "Betalingsdato",
    "admin.payments.table.status": "Status",
    "admin.payments.mark_paid": "Merk betalt",
    "admin.payments.member_summary": "Medlemsbetalingsoversikt",
    "admin.payments.member_overview": "Oversikt over hvert medlems betalingsstatus",
    "admin.payments.total_paid": "Totalt betalt",
    "admin.payments.amount_due": "Beløp å betale",
    "admin.payments.last_payment": "Siste betaling",
    "admin.payments.never": "Aldri",

    // Admin - Event management
    "admin.events.title": "Arrangementshåndtering",
    "admin.events.description": "Opprett og administrer arrangementer og gjentakende serier",

    // Admin - System tab
    "admin.system.user_management": "Brukeradministrasjon",
    "admin.system.user_management_desc": "Administrer brukerkontoer og tillatelser",
    "admin.system.active_users": "Aktive brukere",
    "admin.system.currently_online": "For øyeblikket pålogget: {count}",
    "admin.system.view_all": "Se alle",
    "admin.system.new_registrations": "Nye registreringer",
    "admin.system.pending_approval": "Venter på godkjenning: {count}",
    "admin.system.review": "Gjennomgå",
    "admin.system.manage_users": "Administrer brukere",
    "admin.system.settings": "Systeminnstillinger",
    "admin.system.settings_desc": "Konfigurer systemomfattende innstillinger",
    "admin.system.email_notifications": "E-postvarslinger",
    "admin.system.status_enabled": "Status: Aktivert",
    "admin.system.configure": "Konfigurer",
    "admin.system.data_backup": "Datasikkerhetskopi",
    "admin.system.last_backup": "Siste: {time}",
    "admin.system.backup_now": "Sikkerhetskopier nå",
    "admin.system.data_management": "Datahåndtering",
    "admin.system.data_management_desc": "Eksporter, importer og administrer data",
    "admin.system.export_all": "Eksporter alle data",
    "admin.system.import_data": "Importer data",
    "admin.system.database_cleanup": "Databaseopprydding",
    "admin.system.clear_tournament_cache": "Tøm turneringsmellomlager",
    "admin.system.cache_cleared": "Lagret turneringstilstand tømt",
    "admin.system.reset_system": "Tilbakestill system",
    "admin.system.recent_activity": "Nylig aktivitet",
    "admin.system.activity_log": "Systemaktivitetslogg",
    "admin.system.user_registered": "Bruker registrert",
    "admin.system.event_created": "Arrangement opprettet",
    "admin.system.group_updated": "Gruppe oppdatert",
    "admin.system.backup_completed": "Systemsikkerhetskopi fullført",
    "admin.system.time_ago.minutes": "{count} minutter siden",
    "admin.system.time_ago.hours": "{count} time siden",

    // Admin - System stats
    "admin.stats.health.excellent": "Utmerket",
    "admin.stats.uptime": "{percent}% oppetid",
    "admin.stats.groups_subgroups": "{groups} grupper, {subgroups} undergrupper",

    // Admin - Penalties (additional)
    "admin.penalties.dot": "prikk",
    "admin.penalties.dots": "prikker",
    "admin.penalties.level_penalty": "(Nivå {level} straff)",
    "admin.penalties.member_id": "Medlem {id}",
    "admin.penalties.overview": "Oversikt",

    // Admin - Mobile section headers
    "admin.mobile.events": "Arrangementer",
    "admin.mobile.payments": "Betalinger",
    "admin.mobile.tournaments": "Turneringer",
    "admin.mobile.penalties": "Straffer",
    "admin.mobile.overview": "Oversikt",
    
    // Admin - Reset system
    "admin.reset_system.confirm": "Er du sikker på at du vil tilbakestille systemet? Dette vil slette alle brukerdata og arrangementer.",
    "admin.reset_system.success": "System tilbakestilt vellykket",
    "admin.reset_system.error": "Kunne ikke tilbakestille system",
    
    // Notifications
    "notifications.title": "Varsler",
    "notifications.subtitle": "Hold deg oppdatert med dine siste aktiviteter",
    "notifications.unread_count": "({count} uleste)",
    "notifications.mark_all_read": "Merk alle som lest",
    "notifications.loading": "Laster dine varsler...",
    "notifications.filter.all": "Alle",
    "notifications.filter.unread": "Uleste",
    "notifications.filter.event": "Arrangementer",
    "notifications.filter.tournament": "Turneringer",
    "notifications.filter.message": "Meldinger",
    "notifications.filter.penalty": "Straffer",
    "notifications.empty.title": "Ingen varsler",
    "notifications.empty.description": "Du er oppdatert! Ingen nye varsler.",
    "notifications.empty.filtered": "Ingen {filter} varsler.",
    "notifications.new_badge": "Ny",
    "notifications.click_details": "Klikk for å se detaljer →",
    "notifications.time.minutes": "{count}m siden",
    "notifications.time.hours": "{count}t siden",
    "notifications.time.days": "{count}d siden",
    
    // Loading states
    "common.loading": "Laster...",
    "common.created": "opprettet",
    "tournament.preparing": "Forbereder turnering...",
    "tournament.starting": "Starter turnering...",
    
    // Tournament additional
    "tournament.enter_results": "Registrer resultater",
    "tournament.points": "poeng",
    "tournament.court": "Bane",
    "tournament.select_points_for": "Velg poeng for",
    "tournament.go_to_next_round": "Gå til neste runde",
    
    // Auth
    "auth.required": "Pålogging påkrevd",
    "auth.login_success": "Du er nå logget inn!",
    "auth.login_error": "Innlogging feilet. Sjekk e-post og passord.",
    "auth.logout_success": "Du er nå logget ut.",
    "auth.signup_success": "Registrering vellykket! Velkommen.",
    "auth.signup_error": "Registrering feilet. Prøv igjen.",
    
    // Event actions
    "event.participant.removed": "Deltaker fjernet",
    "event.signup.error": "Påmelding feilet. Prøøv igjen.",
    
    // Admin - Event Management (additional)
    "admin.create_new_event": "Opprett ny hendelse",
    "admin.recurring_info": "Gjentakende informasjon",
    "admin.series_details": "Serie-detaljer",
    "admin.repeats_until": "Gjentas til",
    "admin.total_events_in_series": "Totalt antall hendelser",
    "admin.will_create_events": "Vil opprette {count} hendelser",
    "admin.view_full_series": "Se hele serien",
  },
  en: {
    "tournament.title": "Padel Social Tournament",
    "tournament.date": "Date:",
    "tournament.time": "Time:",
    "tournament.location": "Location:",
    "tournament.courts": "Courts:",
    "tournament.level": "Level:",
    "tournament.level.all": "All levels",
    "tournament.courts.numbers": "2, 3 and 4",
    "tournament.spots": "spots available out of",
    "tournament.participants": "Registered participants:",
    "tournament.fetching": "Fetching participant information... Are you",
    "tournament.logged_in": "logged in",
    "tournament.welcome": "Welcome",
    "tournament.deadline": "Unregister deadline",
    "tournament.24hours": ", 3:00 PM (24 hours before the start)",
    "tournament.confirmed": "Congratulations! You have secured a spot. See you on {day}!",
    "tournament.waitlist.info": "This event is full, but you can sign up for the waiting list. If a spot becomes available, you will be notified by email.",
    "tournament.waitlist.position": "You will be number",
    "tournament.waitlist.onList": "in the waiting list",
    "tournament.waitlist.button": "Join waiting list",
    "tournament.waitlist.joined": "You are on the waiting list. If a spot becomes available, you will be notified by email.",
    "tournament.waitlist.signup.success": "You are now on the waitlist, position {position}. If a spot opens up, you will be notified!",
    "tournament.registration.opens": "Registration opens for all members in",
    "tournament.registration.timeUnits": "day,hours,minutes",
    "tournament.back": "Back to NTNUi Padel Tennis",
    "map": "Map",
    "tournament.success": "✅ Success",
    "tournament.signup.button": "Sign up",
    "tournament.signup.success": "Sign up successful!",
    "tournament.signup.error": "Sign up failed",
    "tournament.signup.waitlist": "You have now joined the waiting list!",
    "tournament.signup.registered": "You are now registered",
    "tournament.cancel.button": "Cancel Participation",
    "tournament.cancel.confirm": "Are you sure you want to cancel participation?",
    "tournament.cancel.success": "Unregistered",
    "tournament.cancel.success.message": "You have been removed from the tournament.",
    "tournament.cancel.waitlist.success": "You have been removed from the waitlist.",
    "tournament.cancel.error": "Could not remove you from the tournament.",
    "tournament.waitlist.count": "people in waiting list",
    "tournament.format.americano": "Americano",
    "tournament.format.mexicano": "Mexicano",
    "tournament.format.winner_court": "Winner-Court with Split",
    "tournament.format.winner_court_team": "Team Winner-Court",
    "tournament.format.team_americano": "Team Americano",
    "tournament.mexicano.start": "Start Mexicano Tournament",
    "tournament.mexicano.started": "Mexicano tournament has started!",
    "tournament.mexicano.round": "Round {round}",
    "tournament.mexicano.next_round": "Starting round {round}",
    "tournament.mexicano.court": "Court {number}",
    "tournament.mexicano.team": "Team",
    "tournament.mexicano.vs": "vs",
    "tournament.mexicano.score": "Score",
    "tournament.mexicano.submit_results": "Save Results",
    "tournament.mexicano.incomplete_results": "Please enter results for all courts",
    "tournament.mexicano.invalid_scores": "Invalid score: Winner team must have higher score than loser team and score cannot be more than 24",
    "tournament.mexicano.finished": "Tournament is finished!",
    "tournament.mexicano.tournament_complete": "Tournament complete!",
    "tournament.mexicano.leaderboard": "Leaderboard",
    "tournament.mexicano.player": "Player",
    "tournament.mexicano.points": "Points",
    "tournament.mexicano.matches": "Matches",
    "tournament.mexicano.reset": "Tournament has been reset",
    "tournament.mexicano.show_leaderboard": "Show leaderboard",
    "tournament.mexicano.hide_leaderboard": "Hide leaderboard",
    "tournament.mexicano.winner_team": "Winner team",
    "tournament.mexicano.court_assignments": "Court assignments",
    "tournament.data_saved": "Tournament data saved to database!",
    "tournament.data_save_failed": "Failed to save tournament data to database",
    "tournament.mexicano.enter_results": "Enter results",
    "tournament.mexicano.won": "won",
    "tournament.mexicano.select_left_team_score": "Select points for left team",
    "tournament.mexicano.tie": "Tie",
     
    // Landing page translations
    "landing.hero.title": "NTNUI Padel", 
    "landing.hero.subtitle": "Lyst til å spille padel tennis?",
    "landing.hero.description": "Det er flere treninger hver uke og alle økter varer i 1.5 time. Drop-in system - meld deg på 72 timer i forveien.",
    "landing.hero.join": "Bli medlem",
    "landing.hero.signin": "Logg inn",
    
    "landing.schedule.title": "Faste treningsøkter",
    "landing.schedule.subtitle": "Drop-in trening - meld deg på 72 timer i forveien",
    "landing.schedule.courts": "baner",
    "landing.schedule.tuesday": "Tirsdag",
    "landing.schedule.thursday": "Torsdag", 
    "landing.schedule.friday.early": "Fredag (tidlig)",
    "landing.schedule.friday.late": "Fredag (sen)",
    "landing.schedule.saturday": "Lørdag",
    "landing.schedule.sunday.early": "Søndag (tidlig)",
    "landing.schedule.sunday.late": "Søndag (sen)",
    
    "landing.levels.title": "Padel nivåer",
    "landing.levels.beginner.name": "Nybegynner",
    "landing.levels.beginner.description": "For nye spillere som lærer grunnleggende teknikk",
    "landing.levels.medium.name": "Medium",
    "landing.levels.medium.description": "Spillere med noe erfaring og grunnleggende ferdigheter",
    "landing.levels.medium_plus.name": "Medium+",
    "landing.levels.medium_plus.description": "Erfarne spillere med god teknikk",
    "landing.levels.advanced.name": "Viderekommende",
    "landing.levels.advanced.description": "Her bør du kunne spille A/B klasse i turneringer",
    "landing.levels.women.name": "Padel dame",
    "landing.levels.women.description": "Her har damer førsteprioritet og kan melde seg på de første 24 timene",
    
    "landing.equipment.title": "Utstyr inkludert",
    "landing.equipment.rackets": "7 racketer tilgjengelig i skap",
    "landing.equipment.balls": "Baller inkludert for alle økter",
    "landing.equipment.access_code": "Skap-kode gis når du melder deg på",
    "landing.equipment.bring_yourself": "Bare ta med deg selv og sportsklær!",
    
    "landing.location.title": "Lokasjon",
    "landing.location.primary": "Padelon Trondheim, Lade",
    "landing.location.entrance": "Bruk inngang ved Maske Marked",
    "landing.location.saturday": "Hit Padel Rosten",
    "landing.location.saturday_note": "Lørdager",
    "landing.location.door_code": "Dørkode gis når du melder deg på",
    "landing.location.padelon": "Padelon Lade",
    "landing.location.hit_padel": "Hit Padel Rosten",
    
    "landing.student_discount.title": "Padelon rabatt tilgjengelig for studentmedlemmer!",
    "landing.student_discount.description": "33% rabatt på hverdager før kl 16. Send studentbevis til Trondheim@Padelon.no",
    
    
    "landing.auth.signin.title": "Logg inn",
    "landing.auth.signin.description": "Logg inn for å se påmeldinger og delta i aktiviteter",
    "landing.auth.signup.title": "Bli medlem",
    "landing.auth.signup.description": "Opprett konto for å delta i NTNUI Padel aktiviteter",
     // Results page
    // Results page
    "tournament.back_to_tournaments": "Back to tournaments",
    "tournament.in_progress": "In progress",
    "tournament.completed": "Completed",
    "tournament.round_results": "Round results",
    "tournament.round": "Round",
    "tournament.final_standings": "Final standings",
    "tournament.rounds": "Rounds",
    "tournament.players": "Players",
    "tournament.not_found": "Tournament not found",
    "tournament.error_loading_results": "Error loading tournament results",
    "tournament.no_results_found": "No tournament results found",
    "tournament.past_tournaments": "Past Tournaments",
    "tournament.no_past_tournaments": "No past tournaments found",

    // Americano translations
    "tournament.americano.start": "Start Americano Tournament",
    "tournament.americano.started": "Americano tournament has started!",
    "tournament.americano.round": "Round {round}",
    "tournament.americano.court": "Court {number}",
    "tournament.americano.team": "Team",
    "tournament.americano.vs": "vs",
    "tournament.americano.start_round": "Start round {round}",
    "tournament.americano.finish_round": "Finish round",
    "tournament.americano.leaderboard": "Leaderboard",
    "tournament.americano.player": "Player",
    "tournament.americano.points": "Points",
    "tournament.americano.games_played": "Games played",
    "tournament.americano.partners": "Different partners",
    "tournament.americano.position": "Position",
    "tournament.americano.description": "Players change partners each round for variety and balance",
    "tournament.americano.submit_results": "Save results",
    "tournament.americano.enter_score": "Enter score",
    
    // Team Americano translations
    "tournament.team_americano.start": "Start Team Americano Tournament",
    "tournament.team_americano.started": "Team Americano tournament has started!",
    "tournament.team_americano.round": "Round {round}",
    "tournament.team_americano.court": "Court {number}",
    "tournament.team_americano.team": "Team",
    "tournament.team_americano.vs": "vs",
    "tournament.team_americano.start_round": "Start round {round}",
    "tournament.team_americano.finish_round": "Finish round",
    "tournament.team_americano.leaderboard": "Leaderboard",
    "tournament.team_americano.team_name": "Team",
    "tournament.team_americano.points": "Points",
    "tournament.team_americano.matches_played": "Matches played",
    "tournament.team_americano.position": "Position",
    "tournament.team_americano.description": "Teams stay together throughout the tournament",
    "tournament.team_americano.submit_results": "Save results",
    "tournament.team_americano.enter_score": "Enter score",
    "event.type": "Event Type",
    "group.select": "Select group",
    "event.waitlist.join": "Join Waiting List",
    "event.waitlist.leave": "Leave Waiting List",
    "event.waitlist.full": "Event is full. You can join the waiting list and will be notified if a spot opens up.",
    "event.waitlist.position": "Position {position} on waiting list",
    "event.waitlist.status": "+{count} waiting",
    "event.signup.success": "Successfully signed up for the event!",
    "event.signup.penalty": "You cannot sign up due to penalty. Check your profile for details.",
    "event.signup.full": "Event is full. Please join the waiting list instead.",
    "event.signup.past_event": "You cannot sign up for an event that has already occurred.",
    "event.cancel.success": "You have been removed from the event.",
    "event.cancel.penalty": "You received 1 dot for cancelling less than 3 hours before start.",
    "event.cancel.promoted": "You have been removed from the event. The next person on the waiting list has been notified.",
    
    // Penalty system
    "penalty.admin.title": "Penalty System",
    "penalty.admin.description": "Manage dots and penalties",
    "penalty.admin.total_dots": "Total dots",
    "penalty.admin.active_penalties": "Active penalties",
    "penalty.admin.late_cancels": "Late cancels",
    "penalty.admin.no_shows": "No shows",
    "penalty.admin.assign_no_show": "Assign No-Show Penalty",
    "penalty.admin.assign_no_show_description": "Assign penalty to member who didn't show up",
    "penalty.admin.select_event": "Select event",
    "penalty.admin.select_event_placeholder": "Select an event...",
    "penalty.admin.select_member": "Select member",
    "penalty.admin.select_member_placeholder": "Select a member...",
    "penalty.admin.assign_penalty": "Assign Penalty",
    "penalty.admin.recent_penalties": "Recent Penalties",
    "penalty.admin.recent_penalties_description": "Overview of recent penalties",
    "penalty.admin.no_penalties": "No penalties recorded",
    "penalty.admin.added": "Penalty assigned to {memberName}",
    "penalty.status.active": "Active",
    "penalty.status.inactive": "Inactive",
    "event.admin.participant_removed": "{name} has been removed from the event.",
    "event.admin.participant_removed_and_promoted": "{removedName} has been removed. {promotedName} has been promoted from the waiting list.",
    "event.waitlist.joined": "You are now on the waitlist, position {position}. If a spot opens up, you will be notified!",
    "event.waitlist.left": "You have been removed from the waiting list.",
    "event.signup.button": "Sign Up",
    "event.cancel.button": "Cancel",
    "event.signup.too_early": "You can sign up {hours} hours before the event starts",
    "event.custom_signup_window": "Signup opens {hours} hours before",
    "event.part_of_series": "Part of recurring series",
    "event.title": "Title",
    "event.description": "Description",
    "event.date": "Date",
    "event.time": "Time",
    "event.location": "Location",
    "event.level": "Level",
    "event.max_participants": "Max participants",
    "event.notes": "Notes",
    
    // Admin event occupancy
    "admin.event_occupancy": "Event Occupancy",
    "admin.event_occupancy.slots_filled": "slots filled",
    "admin.event_occupancy.on_waitlist": "on waitlist",
    "admin.event_occupancy.full_events": "events full",
    "admin.event_occupancy.high_demand": "High demand events",
    "admin.event_occupancy.filled": "filled",
    "admin.event_occupancy.waiting": "waiting",
    "admin.event_occupancy.waitlist_badge": "Waitlist",
    "admin.event_occupancy.nearly_full": "Nearly full",
    
    // Admin signup window settings
    "admin.signup_window": "Signup Window",
    "admin.signup_window_description": "Configure when users can sign up for events",
    "admin.default_signup_window": "Default Signup Window",
    "admin.default_signup_window_description": "Default hours before event users can sign up",
    "admin.signup_window_save": "Save Settings",
    "admin.signup_window_hours": "Hours",
    "admin.signup_window_updated": "Signup window updated",
    "admin.edit_event": "Edit Event",
    "admin.delete_event": "Delete Event",
    "admin.event_updated": "Event updated",
    "admin.event_deleted": "Event deleted",
    "admin.edit_scope": "Edit Scope",
    "admin.edit_scope.single": "This event only",
    "admin.edit_scope.future": "This and future events",
    "admin.edit_recurring_prompt": "Which events do you want to edit?",
    "admin.edit_scope.single_description": "Changes will only apply to this event",
    "admin.edit_scope.future_description": "Changes will apply to this event and all future events in the series",
    "admin.edit_scope.confirm": "Confirm and Save",
    "admin.custom_signup_window": "Custom Signup Window",
    "admin.use_default_signup": "Use default",
    "admin.create_event": "Create Event",
    "admin.create_recurring_event": "Create Recurring",
    "admin.recurrence.none": "No Recurrence",
    "admin.recurrence.weekly": "Weekly",
    "admin.recurrence.biweekly": "Every Two Weeks",
    "admin.recurrence.monthly": "Monthly",
    "admin.recurrence_pattern": "Recurrence Pattern",
    "admin.recurrence_end_date": "End Date",
    "admin.generate_series": "Generate Series",
    "admin.view_series": "View Series",
    "admin.delete_series": "Delete Series",
    "admin.delete_scope.single": "This event only",
    "admin.delete_scope.future": "This and future events",
    "admin.delete_scope.all": "Entire series",
    "admin.delete_recurring_prompt": "This is a recurring event. Choose what to delete:",
    "admin.delete_confirm.single_recurring": "Other events in the series will remain.",
    "admin.delete_confirm.single_standalone": "Are you sure you want to delete this event? This action cannot be undone.",
    "admin.delete_confirm.future": "Deletes this and all future events in the series.",
    "admin.delete_confirm.all": "Permanently deletes all events in this series.",
    "admin.event_list": "All Events",
    "admin.past_events": "Past Events",
    "admin.upcoming_events": "Upcoming Events",
    "admin.event_created": "Event created",
    "admin.series_updated": "Series updated",
    "event.recurring_badge": "Recurring",
    "event.using_default_signup": "Using default signup window",
    "event.past": "This event has already occurred",
    "event.details": "Event Details",
    "event.not_found.title": "Event Not Found",
    "event.not_found.description": "The event you're looking for doesn't exist.",
    "event.date_time": "Date & Time:",
    "event.location_label": "Location:",
    "event.participants_label": "Participants:",
    "event.group_label": "Group:",
    "event.notes_label": "Notes:",
    "event.signed_up": "You're signed up!",
    "event.participants_count": "participants",
    "event.waiting_list": "You're on the waiting list",
    "event.full": "Event is full",
    "event.join": "Join this event",
    "event.join_waiting_list_info": " - You can join the waiting list",
    "event.leave": "Leave Event",
    "event.leave_waiting_list": "Leave Waiting List",
    "event.join_button": "Join Event",
    "event.join_waiting_list_button": "Join Waiting List",
    "event.signed_up_participants": "Signed Up Participants",
    "event.signup_description": "People who have signed up for this event",
    "event.tournament_type": "Tournament Type",
    "event.select_tournament_type": "Select tournament type",
    "event.americano": "Americano",
    "event.mexicano": "Mexicano",
    "event.team_americano": "Team Americano",
    "event.needs_even_players": "(needs even players)",
    "event.start_tournament": "Start Tournament",
    "event.need_more_players": "Need {count} more players",
    "event.waiting_list_title": "Waiting List",
    "event.waiting_list_empty": "No one on the waiting list",
    "event.position": "Position",
    "event.team_americano_error": "Team Americano requires an even number of players",
    "event.no_participants": "No participants yet",
    "event.be_first": "Be the first to sign up!",
    "event.reminder_title": "Event Reminder",
    "event.reminders_sent": "Reminders sent to {count} members",
    "event.reminders_error": "Failed to send reminders",
    "common.current": "Current",
    "common.admin": "Admin",
    "admin.send_reminder": "Send Reminder",
    "profile.events": "My Events",
    "profile.waitinglist": "Waiting List",
    "profile.no.events": "No registrations", 
    "profile.no.waitinglist": "No waiting list entries",
    "dashboard.title": "Upcoming Events",
    "dashboard.subtitle": "Here's what's happening with your groups and events.",
    "dashboard.participants": "participants",
    "dashboard.week": "Week",
    "dashboard.show_past_events": "Show past events",
    "dashboard.hide_past_events": "Hide past events",
    "dashboard.no_upcoming_events": "No upcoming events right now. Try showing past events for history.",
    "dashboard.no_events_available": "No events available in this range.",
    "event.type.training": "Training",
    "event.type.tournament": "Tournament",
    "event.type.social": "Social",
    "event.group.main": "Main Padel Tennis Group",
    "event.group.beginners": "Beginners Group",
    "event.group.advanced": "Advanced Group",
    "event.group.social": "Social Group",
    "event.weekly.title": "Weekly Padel Tennis Match",
    "event.weekly.description": "Regular weekly practice for all skill levels",
    "event.beginner.title": "Beginner Training",
    "event.beginner.description": "Introduction to Padel Tennis basics",
    "event.tournament.title": "Weekly Tournament",
    "event.tournament.description": "Americano tournament for all members",
    "event.mexicano.title": "Weekly Mexicano Tournament",
    "event.mexicano.description": "Mexicano tournament for all members",
    "event.practice.title": "Small Group Practice",
    "event.practice.description": "Intensive practice session for limited participants",
    "event.social.title": "Weekend Social Event",
    "event.social.description": "Fun social event with food and drinks",
    "nav.events": "Events",
    "nav.calendar": "Calendar",
    "nav.notifications": "Notifications",
    
    // Rating system
    "rating.history": "Rating History",
    "rating.history.no_data": "No rating data available yet",
    "rating.history.play_matches": "Play matches to build your rating history",
    "rating.history.match": "Match",
    "rating.history.change": "Change",
    "rating.history.confidence": "Confidence Interval",
    
    // Calendar translations
    "calendar.week": "Week",
    "calendar.previous_week": "Previous week",
    "calendar.next_week": "Next week",
    "calendar.available_spots": "available spots",
    "calendar.full": "Full",
    "calendar.court": "court",
    "calendar.courts": "courts",
    "calendar.capacity": "Capacity",
    "calendar.signed_up": "Signed up",
    "calendar.today": "Today",
    "calendar.view_details": "View Details",
    "calendar.click_to_view": "Click to view details",
    "calendar.signup": "Sign up",
    "calendar.leave": "Leave",
    "calendar.join_waitlist": "Join waitlist",
    "calendar.leave_waitlist": "Leave waitlist",
    "calendar.desktop_only": "Calendar view only available on desktop",
    
    // Event comments
    "event.comments.title": "Comments",
    "event.comments.empty": "No comments yet. Be the first to comment!",
    "event.comments.placeholder": "Write a comment... Use @ to tag members",
    "event.comments.submit": "Submit",
    "event.comments.delete": "Delete",
    "event.comments.reply": "Reply",
    "event.comments.replying_to": "Replying to {name}",
    "event.comments.cancel_reply": "Cancel reply",
    "event.comments.edited": "(edited)",
    "event.comments.delete_confirm": "Are you sure you want to delete this comment?",
    "event.comments.mention_notification": "{name} tagged you in a comment",
    "event.comments.success": "Comment posted",
    "event.comments.error": "Failed to post comment",
    "event.comments.deleted": "Comment deleted",
    "event.comments.delete_error": "Failed to delete comment",
    "calendar.desktop_only_message": "The calendar view is only available on larger screens for a better experience.",
    "nav.messages": "Messages",
    "messages.load_earlier": "Load earlier",
    "loading": "Loading…",
    "messages.new_messages": "New messages",
    "messages.scroll_to_latest": "Scroll to latest",
    "messages.typing": "is typing…",
    "messages.conversation_not_found": "Conversation not found",
    "messages.no_messages_yet": "No messages yet. Start the conversation!",
    "messages.you": "You",
    "messages.retry": "Retry",
    "messages.start_chat": "Start chat",
    "messages.failed_to_start_chat": "Failed to start chat",
    "nav.tournaments": "Tournaments",
    "nav.rankings": "Rankings",
    "nav.profile": "Profile",
    "nav.members": "Members",
    "nav.admin": "Admin",
    "nav.groups": "Groups",
    "nav.subgroups": "Subgroups",
    "nav.signout": "Sign out",
    "rankings.title": "Rankings",
    "rankings.overview": "Player Rankings",
    "rankings.player": "Player",
    "rankings.rating": "Rating",
    "rankings.deviation": "Deviation",
    "rankings.events": "Sessions",
    "rankings.recentActivity": "Recent Sessions",
    "rankings.noActivity": "No recent sessions",
    "rankings.date": "Date",
    "rankings.time": "Time",
    "rankings.event": "Session",
    "rankings.location": "Location",
    "welcome.back": "Welcome back",
    "welcome.members": "Members",
    "welcome.subgroups": "Subgroups",
    "admin.title": "Administration",
    "admin.access_denied": "Access Denied",
    "admin.access_denied.message": "You need administrator privileges to access this page.",
    "admin.total_users": "Total Users",
    "admin.active_groups": "Active Groups",
    "admin.total_events": "Total Events",
    "admin.system_health": "System Health",
    "admin.registered_members": "Registered members",
    "admin.including_subgroups": "Including subgroups",
    "admin.all_time_events": "All time events",
    "admin.all_systems_operational": "All systems operational",
    "admin.this_month": "this month",
    "admin.new_groups": "new groups",
    "app.title": "NTNUi Padel",
    "nav.back": "Back",
    "members.subtitle": "Explore all registered members",
    "members.all": "All Members",
    "members.admins": "Admins",
    "members.admin": "Admin",
    "members.add": "Add Member",
    "members.edit": "Edit Member",
    "members.delete": "Delete Member",
    "members.noMembers": "No members found.",
    "members.createMember": "Create New Member",
    "members.editMember": "Edit Member",
    "members.deleteMember": "Delete Member",
    "members.memberCreated": "Member Created",
    "members.memberCreatedDesc": "{{name}} has been added successfully",
    "members.memberUpdated": "Member Updated", 
    "members.memberUpdatedDesc": "{{name}} has been updated successfully",
    "members.memberDeleted": "Member Deleted",
    "members.memberDeletedDesc": "{{name}} has been removed",
    "members.deleteConfirmation": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "members.deleteWarning": "This will permanently remove the member from all groups and tournaments.",
    "members.updateMember": "Update Member",
    "members.basicInfo": "Basic Information",
    "members.name": "Name",
    "members.phone": "Phone",
    "members.email": "Email",
    "members.enterName": "Enter full name",
    "members.roleAndPermissions": "Role & Permissions",
    "members.role": "Role",
    "members.adminPrivileges": "Admin privileges",
    "members.groupMembership": "Group Membership",
    "members.groups": "Groups",
    "members.subgroups": "Subgroups",
    "members.count.members": "members",
    "members.count.admins": "admins",
    "members.of_total": "of total",
    "members.growth": "Growth",
    "members.last_month": "last month",
    "members.filters": "Filters",
    "members.advanced_filters": "Advanced Filters",
    "members.member_type": "Member Type",
    "members.admins_only": "Admins Only",
    "members.contact_info": "Contact Info",
    "members.has_email": "Has Email",
    "members.has_phone": "Has Phone",
    "members.export": "Export",
    "members.exported": "members exported",
    "members.export_failed": "Export failed",
    "members.contact_completeness": "Contact completeness",
    "members.complete_contact": "Complete contact",
    "members.missing_email": "Missing email",
    "members.missing_phone": "Missing phone",
    "members.editMemberDescription": "Edit member information and settings",
    "common.success": "Success",
    "common.clear": "Clear",
    "groups.filter.select": "Select Groups",
     
    // Validation
    "validation.required": "This field is required",
    "validation.invalidEmail": "Please enter a valid email address",
    "validation.invalidPhone": "Please enter a valid phone number",
    "validation.minLength": "Must be at least {{min}} characters",
    "validation.maxLength": "Must be no more than {{max}} characters",
    "validation.invalidFormat": "Invalid format",
    "validation.phoneFormat": "Please enter a valid phone number",
    "validation.emailFormat": "Please enter a valid email address",
    "validation.selectGroup": "Please select at least one group",
    
    // Common
    "common.save": "Save",
    "common.saving": "Saving...",
    "common.cancel": "Cancel",
    "common.error": "Error",
    "common.prev": "Previous",
    "common.next": "Next",
    "common.page": "Page",
    
    // Placeholders
    "placeholder.searchMembers": "Search members...",
    "placeholder.phoneNumber": "+47 123 45 678",
    "placeholder.email": "example@email.com",
    
    // Groups
    "groups.title": "Groups",
    "groups.subtitle": "View your main groups and members",
    "groups.subgroups.title": "Subgroups",
    "groups.subgroups.subtitle": "View Padel Tennis subgroups and their members", 
    "groups.create": "Create Group",
    "groups.createSubgroup": "Create Subgroup",
    "groups.edit": "Edit Group",
    "groups.members": "members",
    "groups.subgroups": "subgroups",
    "groups.events": "events",
    "groups.expandMembers": "Show members",
    "groups.collapseMembers": "Hide members",
    "groups.addMember": "Add member",
    "groups.removeMember": "Remove member",
    "groups.noMembers": "No members",
    "groups.loading": "Loading groups...",
    "groups.error": "Failed to load groups",
    "groups.memberAdded": "Member added",
    "groups.memberRemoved": "Member removed",
    "groups.unknownMember": "Unknown member",
    "groups.filter.all_groups": "All groups",
    "groups.addMembersTo": "Add Members to",
    "groups.roleForSelected": "Role for selected members", 
    "groups.membersSelected": "{{count}} member{{count === 1 ? '' : 's'}} selected",
    "groups.noMembersFound": "No members found matching your search.",
    "groups.allMembersInGroup": "All members are already in this group.",
    "groups.addMembers": "Add {{count}} Member{{count === 1 ? '' : 's'}}",
    "admin.subtitle": "Manage system and users",
    
    // Admin - Tab labels
    "admin.tabs.payments": "Payments",
    "admin.tabs.events": "Events",
    "admin.tabs.tournaments": "Tournaments",
    "admin.tabs.penalties": "Penalties",
    "admin.tabs.system": "System",

    // Admin - Payment section
    "admin.payments.total_revenue": "Total Revenue",
    "admin.payments.revenue_description": "Revenue from paid memberships",
    "admin.payments.payments_received": "payments received",
    "admin.payments.payment_rate": "payment rate",
    "admin.payments.pending_payments": "Pending Payments",
    "admin.payments.outstanding_dues": "Outstanding membership dues",
    "admin.payments.outstanding": "outstanding",
    "admin.payments.overdue": "overdue",
    "admin.payments.member_status": "Member Status",
    "admin.payments.current_status": "Current membership status",
    "admin.payments.status.current": "Current",
    "admin.payments.status.pending": "Pending",
    "admin.payments.status.overdue": "Overdue",
    "admin.payments.status.paid": "Paid",
    "admin.payments.status.all": "All",
    "admin.payments.quick_actions": "Quick Actions",
    "admin.payments.management_tools": "Payment management tools",
    "admin.payments.add_payment": "Add Payment",
    "admin.payments.bulk_create": "Bulk Create",
    "admin.payments.all_records": "All Payment Records",
    "admin.payments.history_tracking": "Complete payment history and status tracking",
    "admin.payments.search_placeholder": "Search member or description",
    "admin.payments.filter.status": "Status",
    "admin.payments.sort_by": "Sort by",
    "admin.payments.sort.due_date": "Due Date",
    "admin.payments.sort.paid_date": "Paid Date",
    "admin.payments.sort.created": "Created",
    "admin.payments.sort.amount": "Amount",
    "admin.payments.sort.asc": "Asc",
    "admin.payments.sort.desc": "Desc",
    "admin.payments.table.member": "Member",
    "admin.payments.table.amount": "Amount",
    "admin.payments.table.due_date": "Due Date",
    "admin.payments.table.paid_date": "Paid Date",
    "admin.payments.table.status": "Status",
    "admin.payments.mark_paid": "Mark Paid",
    "admin.payments.member_summary": "Member Payment Summary",
    "admin.payments.member_overview": "Overview of each member's payment status",
    "admin.payments.total_paid": "Total Paid",
    "admin.payments.amount_due": "Amount Due",
    "admin.payments.last_payment": "Last Payment",
    "admin.payments.never": "Never",

    // Admin - Event management
    "admin.events.title": "Event Management",
    "admin.events.description": "Create and manage events and recurring series",

    // Admin - System tab
    "admin.system.user_management": "User Management",
    "admin.system.user_management_desc": "Manage user accounts and permissions",
    "admin.system.active_users": "Active Users",
    "admin.system.currently_online": "Currently online: {count}",
    "admin.system.view_all": "View All",
    "admin.system.new_registrations": "New Registrations",
    "admin.system.pending_approval": "Pending approval: {count}",
    "admin.system.review": "Review",
    "admin.system.manage_users": "Manage Users",
    "admin.system.settings": "System Settings",
    "admin.system.settings_desc": "Configure system-wide settings",
    "admin.system.email_notifications": "Email Notifications",
    "admin.system.status_enabled": "Status: Enabled",
    "admin.system.configure": "Configure",
    "admin.system.data_backup": "Data Backup",
    "admin.system.last_backup": "Last: {time}",
    "admin.system.backup_now": "Backup Now",
    "admin.system.data_management": "Data Management",
    "admin.system.data_management_desc": "Export, import, and manage data",
    "admin.system.export_all": "Export All Data",
    "admin.system.import_data": "Import Data",
    "admin.system.database_cleanup": "Database Cleanup",
    "admin.system.clear_tournament_cache": "Clear Tournament Cache",
    "admin.system.cache_cleared": "Cached tournament state cleared",
    "admin.system.reset_system": "Reset System",
    "admin.system.recent_activity": "Recent Activity",
    "admin.system.activity_log": "System activity log",
    "admin.system.user_registered": "User registered",
    "admin.system.event_created": "Event created",
    "admin.system.group_updated": "Group updated",
    "admin.system.backup_completed": "System backup completed",
    "admin.system.time_ago.minutes": "{count} minutes ago",
    "admin.system.time_ago.hours": "{count} hours ago",

    // Admin - System stats
    "admin.stats.health.excellent": "Excellent",
    "admin.stats.uptime": "{percent}% uptime",
    "admin.stats.groups_subgroups": "{groups} groups, {subgroups} subgroups",

    // Admin - Penalties (additional)
    "admin.penalties.dot": "dot",
    "admin.penalties.dots": "dots",
    "admin.penalties.level_penalty": "(Level {level} penalty)",
    "admin.penalties.member_id": "Member {id}",
    "admin.penalties.overview": "Overview",

    // Admin - Mobile section headers
    "admin.mobile.events": "Events",
    "admin.mobile.payments": "Payments",
    "admin.mobile.tournaments": "Tournaments",
    "admin.mobile.penalties": "Penalties",
    "admin.mobile.overview": "Overview",
    
    // Admin - Reset system
    "admin.reset_system.confirm": "Are you sure you want to reset the system? This will clear all user data and events.",
    "admin.reset_system.success": "System reset successfully",
    "admin.reset_system.error": "Failed to reset system",
    
    // Notifications
    "notifications.title": "Notifications",
    "notifications.subtitle": "Stay updated with your latest activities",
    "notifications.unread_count": "({count} unread)",
    "notifications.mark_all_read": "Mark all read",
    "notifications.loading": "Loading your notifications...",
    "notifications.filter.all": "All",
    "notifications.filter.unread": "Unread",
    "notifications.filter.event": "Events",
    "notifications.filter.tournament": "Tournaments",
    "notifications.filter.message": "Messages",
    "notifications.filter.penalty": "Penalties",
    "notifications.empty.title": "No notifications",
    "notifications.empty.description": "You're all caught up! No new notifications.",
    "notifications.empty.filtered": "No {filter} notifications.",
    "notifications.new_badge": "New",
    "notifications.click_details": "Click to view details →",
    "notifications.time.minutes": "{count}m ago",
    "notifications.time.hours": "{count}h ago",
    "notifications.time.days": "{count}d ago",
    
    // Loading states
    "common.loading": "Loading...",
    "common.created": "created",
    "tournament.preparing": "Preparing tournament...",
    "tournament.starting": "Starting tournament...",
    
    // Tournament additional
    "tournament.enter_results": "Enter results",
    "tournament.points": "points",
    "tournament.court": "Court",
    "tournament.select_points_for": "Select points for",
    "tournament.go_to_next_round": "Go to next round",
    
    // Auth
    "auth.required": "Login required",
    "auth.login_success": "You are now logged in!",
    "auth.login_error": "Login failed. Please check your email and password.",
    "auth.logout_success": "You are now logged out.",
    "auth.signup_success": "Sign up successful! Welcome.",
    "auth.signup_error": "Sign up failed. Please try again.",

    // Event actions
    "event.participant.removed": "Participant removed",
    "event.signup.error": "Sign up failed. Please try again.",
    
    // Admin - Event Management (additional)
    "admin.create_new_event": "Create New Event",
    "admin.recurring_info": "Recurring Information",
    "admin.series_details": "Series Details",
    "admin.repeats_until": "Repeats until",
    "admin.total_events_in_series": "Total events in series",
    "admin.will_create_events": "Will create {count} events",
    "admin.view_full_series": "View Full Series",
  },
};

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const detectBrowserLanguage = (): Language => {
    const browserLanguage = navigator.language.toLowerCase();
    if (browserLanguage.startsWith('nb') || browserLanguage.startsWith('nn') || browserLanguage.startsWith('no')) {
      return 'no';
    }
    return 'en';
  };

  const [language, setLanguageState] = useState<Language>(detectBrowserLanguage);

  // User-specific language loading/saving - only when auth is available
  useEffect(() => {
    let isMounted = true;
    
    const loadUserLanguage = async () => {
      try {
        // Try to get auth context, but don't fail if it's not available
        const authContext = (window as any).__authContext;
        if (!authContext?.user?.id) return;
        
        const { data } = await supabase
          .from('profiles')
          .select('language')
          .eq('user_id', authContext.user.id)
          .single();
        
        const lang = data?.language;
        if (isMounted && (lang === 'no' || lang === 'en')) {
          setLanguageState(lang);
        }
      } catch (error) {
        // Silently fail - language will default to browser detection
        console.warn('Failed to load user language preference:', error);
      }
    };
    
    loadUserLanguage();
    
    return () => {
      isMounted = false;
    };
  }, []);

  const handleSetLanguage = async (lang: Language) => {
    setLanguageState(lang);
    
    try {
      // Try to save to user profile, but don't fail if auth is not available
      const authContext = (window as any).__authContext;
      if (authContext?.user?.id) {
        await supabase.from('profiles').update({ language: lang }).eq('user_id', authContext.user.id);
      }
    } catch (error) {
      // Silently fail - language change will still work locally
      console.warn('Failed to save language preference:', error);
    }
  };

  const refreshLanguage = async () => {
    try {
      const authContext = (window as any).__authContext;
      if (!authContext?.user?.id) return;
      
      const { data } = await supabase
        .from('profiles')
        .select('language')
        .eq('user_id', authContext.user.id)
        .single();
      
      const lang = data?.language;
      if (lang === 'no' || lang === 'en') {
        setLanguageState(lang);
      }
    } catch (error) {
      console.warn('Failed to refresh language preference:', error);
    }
  };
  

  const t = (key: string, params?: Record<string, string | number>): string => {
    const translation = translations[language][key as keyof typeof translations["en"]] || key;
    
    if (params) {
      return Object.entries(params).reduce((result, [param, value]) => {
        return result.replace(`{${param}}`, String(value));
      }, translation);
    }
    
    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: handleSetLanguage, refreshLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
